package org.example.zone360.utils

class Config {
    companion object {

        var adjustTime = 5f
        var allowedQuestions = 2
        const val MAX_CACHED = 50
        const val ALLOWED_CONVERSATION_HISTORY = 6

    }
}
